import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-slate-50" data-testid="not-found-page">
      <Compass className="w-16 h-16 text-slate-300 mb-6" />
      <h1 className="text-6xl font-bold text-[#0F172A] font-['Manrope']">404</h1>
      <p className="mt-3 text-lg text-muted-foreground">Esta página no existe.</p>
      <Link to="/" className="mt-6">
        <Button data-testid="not-found-home-btn">Volver al inicio</Button>
      </Link>
    </div>
  );
}
